module.exports = __webpack_public_path__ + "images/PhoneNumbers-514d95ad874be1143f915127ad2c65d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/PhoneNumbers.png
// module id = i3H0
// module chunks = 0